/* ========================================================================
//	MAIN
======================================================================== */

(function ($) {
	// BUTTON TOUCH MECHANICS
	MyTools.touch({ el: $('*[data-btn]'), deactivate: 500, funcDelay: 500 });
	
	// ACTIVATE MENU ARROWS FOR MOBILE
	MyTools.menuArrows({ el: $('.menu'), dismissable: 3 });
	
	// COOKIE MSG
	var cookieOK = Cookie.get("kontinuerCookieOK");

	$('[data-fancybox]').fancybox({
		buttons: [
			"zoom",
			//"share",
			// "slideShow",
			//"fullScreen",
			//"download",
			// "thumbs",
			"close"
		],
	});

	if (cookieOK != "") {
		$('#cookieMsg').remove();
	} else {
		MyTools.touch({
			el: $('#cookieOK'),
			deactivate: 500,
			funcDelay: 500,
			func: function () {
				Cookie.set("kontinuerCookieOK", 'OK', 365);
				$('#cookieMsg').addClass('hide');
			}
		});
	}
})(jQuery, MyTools, Cookie);
